import { useState, useEffect } from 'react';
import '../../styles/pages/Admin/Dashboard.scss';
import '../../styles/components/ProductViewModal.scss';
import SERVER from '../../hooks/useServer';
import axios from 'axios';
import {formatPrice} from '../../hooks/generalHooks';
import { TiDelete } from "react-icons/ti";
import { FaDeleteLeft, FaEye } from "react-icons/fa6";
import { MdOutlineModeEdit } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { FiChevronDown } from "react-icons/fi";
import TranslationButton from './TranslationButton';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdminProducts = ({ activeTab, products, setProducts, categories, subCategories }) => {
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inPromotion, setInPromotion] = useState(false);
    const [inCalibrage, setInCalibrage] = useState(false);
    const [newProd, setNewprod] = useState(false);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [selectedRelatedProducts, setSelectedRelatedProducts] = useState([]);
    // Filter and search states
    const [categoryFilter, setCategoryFilter] = useState('');
    const [subCategoryFilter, setSubCategoryFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [displayPrimaryCaracteristiques, setDisplayPrimaryCaracteristiques] = useState(true);
    const [displaySecondaryCaracteristiques, setDisplaySecondaryCaracteristiques] = useState(true);
    const [productImages, setProductImages] = useState([]);
    const [productDocuments, setProductDocuments] = useState([]);
    const [viewProduct, setViewProduct] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [importUrl, setImportUrl] = useState('');
    const [importLoading, setImportLoading] = useState(false);
    const [importError, setImportError] = useState(null);

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const filteredProducts = products.filter(prod => {
        const matchesSearch = (
            prod.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (prod.description && prod.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
            formatPrice(prod.price).includes(searchTerm));
        const matchesCategory = categoryFilter ? prod.category_id === Number(categoryFilter) : true;
        const matchesSubCategory = subCategoryFilter ? prod.sub_category_id === Number(subCategoryFilter) : true;
        return matchesSearch && matchesCategory && matchesSubCategory;
    });

    const handleSelectRelatedProduct = (productId) => {
        setSelectedRelatedProducts(prev => {
            if (prev.includes(productId)) {
            return prev.filter(id => id !== productId);
            } else {
            return [...prev, productId];
            }
        });
    };

    // Paginated data
    const currentProducts = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Image modal handlers
    const openImageModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setIsModalOpen(true);
    };

    const closeImageModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    const openViewModal = (product) => {
        setViewProduct(product);
        setIsViewModalOpen(true);
    };

    const closeViewModal = () => {
        setIsViewModalOpen(false);
        setViewProduct(null);
    };

    const openImportModal = () => {
        setIsImportModalOpen(true);
        setImportUrl('');
        setImportError(null);
    };

    const closeImportModal = () => {
        setIsImportModalOpen(false);
        setImportUrl('');
        setImportError(null);
    };

    const handleImportProduct = async () => {
        if (!importUrl.trim()) {
            setImportError('Veuillez entrer une URL valide');
            toast.error('Veuillez entrer une URL valide');
            return;
        }

        // Validate URL is from kern-sohn.com
        if (!importUrl.includes('kern-sohn.com')) {
            setImportError('L\'URL doit provenir du site kern-sohn.com');
            toast.error('L\'URL doit provenir du site kern-sohn.com');
            return;
        }

        try {
            setImportLoading(true);
            setImportError(null);

            const response = await axios.post(`${SERVER}/products/import-from-url`, {
                url: importUrl
            });

            if (response.data.success) {
                // Populate the form with scraped data
                const scrapedData = response.data.product;
                
                setNewProduct({
                    title: scrapedData.title || '',
                    description: scrapedData.description || '',
                    price: scrapedData.price || 0,
                    category_id: '',
                    sub_category_id: '',
                    banner_image: '',
                    images: [],
                    main_caracteristiques: scrapedData.main_caracteristiques || {},
                    secondary_caracteristiques: scrapedData.secondary_caracteristiques || {},
                    promotion: 0,
                    nouveaute: false,
                    calibrage: '',
                    documents: []
                });

                // Set images if available
                if (scrapedData.imageUrls && scrapedData.imageUrls.length > 0) {
                    // You can handle image URLs here
                    console.log('Images found:', scrapedData.imageUrls);
                }

                closeImportModal();
                toast.success('Produit importé avec succès! Veuillez vérifier et compléter les informations.');
            }
        } catch (err) {
            const errorMsg = err.response?.data?.error || 'Erreur lors de l\'importation du produit';
            setImportError(errorMsg);
            toast.error(errorMsg);
            console.error('Import error:', err);
        } finally {
            setImportLoading(false);
        }
    };

    // Form states
    const [newProduct, setNewProduct] = useState({
        title: '',
        description: '',
        price: 0,
        category_id: '',
        sub_category_id: '',
        banner_image: '',
        images: [],
        main_caracteristiques: {},
        secondary_caracteristiques: {},
        promotion: 0,
        nouveaute: false,
        calibrage: '',
        documents: []
    });
    
    // Characteristic form states
    const [newMainChar, setNewMainChar] = useState({title: '', value: '', unity: ''});
    const [newSecondaryChar, setNewSecondaryChar] = useState({title: '', value: '', unity: ''});
    const [isAddingMainChar, setIsAddingMainChar] = useState(false);
    const [isAddingSecondaryChar, setIsAddingSecondaryChar] = useState(false);
    const [newDocument, setNewDocument] = useState({title: '', file: null});
    const [editingChar, setEditingChar] = useState(null);
    const [editingCharType, setEditingCharType] = useState(null);
    const [draggedChar, setDraggedChar] = useState(null);
    const [draggedCharType, setDraggedCharType] = useState(null);

    // Default characteristics templates
    const defaultMainCharacteristics = {
        plage_de_mesure: { title: 'Plage de mesure', value: '', unity: '' },
        lecture: { title: 'Lecture', value: '', unity: '' },
        surface_de_pesee: { title: 'Surface de pesée', value: '', unity: '' }
    };

    const defaultSecondaryCharacteristics = {
        portee_max: { title: 'Portée [Max]', value: '', unity: '' },
        lecture_d: { title: 'Lecture [d]', value: '', unity: '' },
        unites_de_mesure: { title: 'Unités de mesure', value: '', unity: '' },
        linearite: { title: 'Linéarité', value: '', unity: '' },
        reproductibilite: { title: 'Reproductibilité', value: '', unity: '' },
        temps_de_stabilisation: { title: 'Temps de stabilisation', value: '', unity: '' },
        interfaces: { title: 'Interfaces', value: '', unity: '' },
        possibilites_ajustage: { title: "Possibilités d'ajustage", value: '', unity: '' },
        poids_de_reglage_recommande: { title: 'Poids de réglage recommandé', value: '', unity: '' },
        temperature_ambiante: { title: 'Température ambiante', value: '', unity: '' },
        dimensions_surface_pesee: { title: 'Dimensions surface de pesée (Ø)', value: '', unity: '' },
        materiau_chambre_protection: { title: 'Matériau chambre de protection', value: '', unity: '' },
        materiau_boitier: { title: 'Matériau boîtier', value: '', unity: '' },
        dimensions_boitier: { title: 'Dimensions boîtier (L×P×H)', value: '', unity: '' },
        poids_net: { title: 'Poids net env.', value: '', unity: '' },
        type_construction: { title: 'Type de construction de la balance', value: '', unity: '' },
        gtin_ean: { title: 'GTIN/Numéro EAN', value: '', unity: '' }
    };

    const titleToKey = (title) => {
        return title.toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const handleAddMainCharacteristic = () => {
        if (!newMainChar.title.trim()) {
            toast.error('Le titre de la caractéristique est requis');
            return;
        }
        if (!newMainChar.value.trim()) {
            toast.error('La valeur de la caractéristique est requise');
            return;
        }

        const key = titleToKey(newMainChar.title);
        setNewProduct({
            ...newProduct,
            main_caracteristiques: {
                ...newProduct.main_caracteristiques,
                [key]: {
                    title: newMainChar.title,
                    value: newMainChar.value,
                    unity: newMainChar.unity
                }
            }
        });
        setNewMainChar({title: '', value: '', unity: ''});
        setIsAddingMainChar(false);
        toast.success('Caractéristique principale ajoutée');
    };

    const handleAddSecondaryCharacteristic = () => {
        if (!newSecondaryChar.title.trim()) {
            toast.error('Le titre de la caractéristique est requis');
            return;
        }
        if (!newSecondaryChar.value.trim()) {
            toast.error('La valeur de la caractéristique est requise');
            return;
        }

        const key = titleToKey(newSecondaryChar.title);
        setNewProduct({
            ...newProduct,
            secondary_caracteristiques: {
                ...newProduct.secondary_caracteristiques,
                [key]: {
                    title: newSecondaryChar.title,
                    value: newSecondaryChar.value,
                    unity: newSecondaryChar.unity
                }
            }
        });
        setNewSecondaryChar({title: '', value: '', unity: ''});
        setIsAddingSecondaryChar(false);
        toast.success('Caractéristique secondaire ajoutée');
    };

    const handleLoadDefaultCharacteristics = (type) => {
        if (type === 'main') {
            setNewProduct({
                ...newProduct,
                main_caracteristiques: {
                    ...newProduct.main_caracteristiques,
                    ...defaultMainCharacteristics
                }
            });
            toast.success('Caractéristiques principales par défaut chargées');
        } else {
            setNewProduct({
                ...newProduct,
                secondary_caracteristiques: {
                    ...newProduct.secondary_caracteristiques,
                    ...defaultSecondaryCharacteristics
                }
            });
            toast.success('Caractéristiques secondaires par défaut chargées');
        }
    };

    const handleEditCharacteristic = (key, char, type) => {
        setEditingChar({ key, ...char });
        setEditingCharType(type);
    };

    const handleSaveEditCharacteristic = () => {
        if (!editingChar) return;
        
        if (!editingChar.title.trim()) {
            toast.error('Le titre de la caractéristique est requis');
            return;
        }
        if (!editingChar.value.trim()) {
            toast.error('La valeur de la caractéristique est requise');
            return;
        }

        const { key, title, value, unity } = editingChar;
        const newKey = titleToKey(title);
        
        if (editingCharType === 'main') {
            const updatedChars = { ...newProduct.main_caracteristiques };
            if (key !== newKey) {
                delete updatedChars[key];
            }
            updatedChars[newKey] = { title, value, unity };
            setNewProduct({
                ...newProduct,
                main_caracteristiques: updatedChars
            });
        } else {
            const updatedChars = { ...newProduct.secondary_caracteristiques };
            if (key !== newKey) {
                delete updatedChars[key];
            }
            updatedChars[newKey] = { title, value, unity };
            setNewProduct({
                ...newProduct,
                secondary_caracteristiques: updatedChars
            });
        }
        
        toast.success('Caractéristique modifiée avec succès');
        setEditingChar(null);
        setEditingCharType(null);
    };

    const handleCancelEditCharacteristic = () => {
        setEditingChar(null);
        setEditingCharType(null);
    };

    // Drag and drop handlers for characteristics
    const handleDragStart = (e, key, type) => {
        setDraggedChar(key);
        setDraggedCharType(type);
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleDrop = (e, targetKey, type) => {
        e.preventDefault();
        
        if (draggedChar === targetKey || draggedCharType !== type) return;

        const chars = type === 'main' 
            ? newProduct.main_caracteristiques 
            : newProduct.secondary_caracteristiques;

        const entries = Object.entries(chars);
        const draggedIndex = entries.findIndex(([key]) => key === draggedChar);
        const targetIndex = entries.findIndex(([key]) => key === targetKey);

        if (draggedIndex === -1 || targetIndex === -1) return;

        // Reorder the entries
        const [removed] = entries.splice(draggedIndex, 1);
        entries.splice(targetIndex, 0, removed);

        // Convert back to object
        const reorderedChars = Object.fromEntries(entries);

        if (type === 'main') {
            setNewProduct({
                ...newProduct,
                main_caracteristiques: reorderedChars
            });
        } else {
            setNewProduct({
                ...newProduct,
                secondary_caracteristiques: reorderedChars
            });
        }

        setDraggedChar(null);
        setDraggedCharType(null);
    };

    const handleDragEnd = () => {
        setDraggedChar(null);
        setDraggedCharType(null);
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file,
            preview: URL.createObjectURL(file)
        }));
        setProductImages([...productImages, ...newImages]);
    };

    const handleRemoveImage = (index) => {
        const updatedImages = [...productImages];
        URL.revokeObjectURL(updatedImages[index].preview);
        updatedImages.splice(index, 1);
        setProductImages(updatedImages);
        toast.success('Image supprimée');
    };

    const handleDocumentUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewDocument({
                ...newDocument,
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const handleAddDocument = () => {
            if (!newDocument.title.trim()) {
                toast.error('Le titre du document est requis');
                return;
            }
            if (!newDocument.file) {
                toast.error('Veuillez sélectionner un fichier');
                return;
            }

            setNewProduct({
                ...newProduct,
                documents: [...newProduct.documents, {
                    title: newDocument.title,
                    file: newDocument.file
                }]
            });
            setNewDocument({title: '', file: null});
            toast.success('Document ajouté');
        };

        const handleRemoveDocument = (index) => {
            const updatedDocs = [...newProduct.documents];
            if (updatedDocs[index].preview) {
                URL.revokeObjectURL(updatedDocs[index].preview);
            }
            updatedDocs.splice(index, 1);
            setNewProduct({
                ...newProduct,
                documents: updatedDocs
            });
            toast.success('Document retiré');
        };

        // Update the handleAddProduct and handleUpdate functions:
        const handleAddProduct = async () => {
        // Validation
        if (!newProduct.title.trim()) {
            toast.error('Le nom du produit est requis');
            return;
        }
        if (!newProduct.price || newProduct.price <= 0) {
            toast.error('Le prix doit être supérieur à 0');
            return;
        }
        if (!newProduct.category_id) {
            toast.error('Veuillez sélectionner une catégorie');
            return;
        }

        // Check for duplicate product name
        const duplicateProduct = products.find(
            p => p.title.toLowerCase().trim() === newProduct.title.toLowerCase().trim()
        );
        if (duplicateProduct) {
            toast.error('Un produit avec ce nom existe déjà');
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('title', newProduct.title);
            formData.append('description', newProduct.description);
            formData.append('price', newProduct.price);
            formData.append('category_id', newProduct.category_id);
            formData.append('sub_category_id', newProduct.sub_category_id);
            formData.append('main_caracteristiques', JSON.stringify(newProduct.main_caracteristiques));
            formData.append('secondary_caracteristiques', JSON.stringify(newProduct.secondary_caracteristiques));
            formData.append('promotion', newProduct.promotion);
            formData.append('nouveaute', newProduct.nouveaute);
            formData.append('calibrage',newProduct.calibrage);
            const relatedProductIds = selectedRelatedProducts.map(id => parseInt(id));
            formData.append('related_products', JSON.stringify(relatedProductIds));
            if (newProduct.banner_imageFile) {
            formData.append('banner_image', newProduct.banner_imageFile);
            }

            // Add multiple images
            productImages.forEach((image) => {
            if (image.file) {
                formData.append('images', image.file);
            }
            });

            // Add documents - simplified format
            newProduct.documents.forEach((doc) => {
            if (doc.file) {
                formData.append('documents', doc.file);
            }
            });

            const response = await axios.post(`${SERVER}/products`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            });
            
            setProducts([...products, response.data.product]);
            toast.success('Produit ajouté avec succès');
            
            // Reset form
            setNewProduct({
                title: '',
                description: '',
                price: 0,
                category_id: '',
                sub_category_id: '',
                banner_image: '',
                images: [],
                main_caracteristiques: {},
                secondary_caracteristiques: {},
                promotion: 0,
                nouveaute: false,
                calibrage: '',
                documents: []
            });
            setProductImages([]);
            setProductDocuments([]);
            setSelectedRelatedProducts([]);
            setInPromotion(false);
            setNewprod(false);
            setInCalibrage(false);
            setError(null);
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message;
            setError(errorMsg);
            toast.error(`Erreur: ${errorMsg}`);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async () => {
        // Validation
        if (!newProduct.title.trim()) {
            toast.error('Le nom du produit est requis');
            return;
        }
        if (!newProduct.price || newProduct.price <= 0) {
            toast.error('Le prix doit être supérieur à 0');
            return;
        }
        if (!newProduct.category_id) {
            toast.error('Veuillez sélectionner une catégorie');
            return;
        }

        // Check for duplicate product name (excluding current product)
        const duplicateProduct = products.find(
            p => p.id !== selectedProduct.id && 
            p.title.toLowerCase().trim() === newProduct.title.toLowerCase().trim()
        );
        if (duplicateProduct) {
            toast.error('Un produit avec ce nom existe déjà');
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            
            // Only append fields that have changed
            if (newProduct.title !== selectedProduct.title) {
                formData.append('title', newProduct.title);
            }
            if (newProduct.description !== selectedProduct.description) {
                formData.append('description', newProduct.description);
            }
            if (newProduct.price !== selectedProduct.price) {
                formData.append('price', newProduct.price);
            }
            if (newProduct.category_id !== selectedProduct.category_id) {
                formData.append('category_id', newProduct.category_id);
            }
            if (newProduct.sub_category_id !== selectedProduct.sub_category_id) {
                formData.append('sub_category_id', newProduct.sub_category_id);
            }
            if (newProduct.promotion !== selectedProduct.promotion) {
                formData.append('promotion', newProduct.promotion);
            }
            if (newProduct.nouveaute !== selectedProduct.nouveaute) {
                formData.append('nouveaute', newProduct.nouveaute);
            }
            if (newProduct.calibrage !== selectedProduct.calibrage) {
                formData.append('calibrage', newProduct.calibrage);
            }
    
            // Handle characteristics
            if (JSON.stringify(newProduct.main_caracteristiques) !== JSON.stringify(selectedProduct.main_caracteristiques || {})) {
                formData.append('main_caracteristiques', JSON.stringify(newProduct.main_caracteristiques));
            }
            if (JSON.stringify(newProduct.secondary_caracteristiques) !== JSON.stringify(selectedProduct.secondary_caracteristiques || {})) {
                formData.append('secondary_caracteristiques', JSON.stringify(newProduct.secondary_caracteristiques));
            }
    
            // Handle related products
            const currentRelatedIds = selectedProduct.related_products?.map(p => p.id) || [];
            if (JSON.stringify(selectedRelatedProducts.sort()) !== JSON.stringify(currentRelatedIds.sort())) {
                formData.append('related_products', JSON.stringify(selectedRelatedProducts));
            }
    
            // Handle images - keep existing images properly
            const imagesToKeep = productImages
                .filter(img => img.isExisting && img.originalPath)
                .map(img => img.originalPath);
            
            if (imagesToKeep.length > 0 || productImages.some(img => !img.isExisting)) {
                formData.append('images_to_keep', JSON.stringify(imagesToKeep));
            }
            
            // Add new images
            productImages.forEach((image) => {
                if (image.file && !image.isExisting) {
                    formData.append('images', image.file);
                }
            });
    
            // Handle banner image - only update if changed
            if (newProduct.banner_imageFile) {
                formData.append('banner_image', newProduct.banner_imageFile);
            }
    
            // Handle documents
            const existingDocs = selectedProduct.documents || [];
            const docsToKeep = existingDocs.filter(doc => 
                newProduct.documents.some(newDoc => newDoc.id === doc.id)
            ).map(doc => doc.id);
            
            formData.append('documents_to_keep', JSON.stringify(docsToKeep));
            
            // Add new documents
            newProduct.documents.forEach((doc) => {
                if (doc.file && !doc.id) {
                    formData.append('documents', doc.file);
                }
            });
    
            const response = await axios.put(`${SERVER}/products/${selectedProduct.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            setProducts(products.map(product => 
                product.id === response.data.product.id ? response.data.product : product
            ));
            
            toast.success('Produit mis à jour avec succès');
            
            setIsEditing(false);
            setSelectedProduct(null);
            setProductImages([]);
            setProductDocuments([]);
            setSelectedRelatedProducts([]);
            setInPromotion(false);
            setNewprod(false);
            setInCalibrage(false);
            setError(null);
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message;
            setError(errorMsg);
            toast.error(`Erreur: ${errorMsg}`);
            console.error('Update error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (type, id) => {
        // Confirmation dialog
        const confirmMessages = {
            'product': 'Êtes-vous sûr de vouloir supprimer ce produit ?',
            'mainChar': 'Supprimer cette caractéristique principale ?',
            'secondaryChar': 'Supprimer cette caractéristique secondaire ?',
            'document': 'Supprimer ce document ?'
        };

        if (!window.confirm(confirmMessages[type] || 'Confirmer la suppression ?')) {
            return;
        }

        try {
            setLoading(true);
            let endpoint = '';
            switch(type) {
                case 'product':
                    endpoint = `${SERVER}/products/${id}`;
                    break;
                case 'mainChar':
                    const updatedMainChars = {...newProduct.main_caracteristiques};
                    delete updatedMainChars[id];
                    setNewProduct({
                        ...newProduct,
                        main_caracteristiques: updatedMainChars
                    });
                    toast.success('Caractéristique principale supprimée');
                    return;
                case 'secondaryChar':
                    const updatedSecondaryChars = {...newProduct.secondary_caracteristiques};
                    delete updatedSecondaryChars[id];
                    setNewProduct({
                        ...newProduct,
                        secondary_caracteristiques: updatedSecondaryChars
                    });
                    toast.success('Caractéristique secondaire supprimée');
                    return;
                case 'document':
                    await axios.delete(`${SERVER}/products/documents/${id}`);
                    setProductDocuments(productDocuments.filter(doc => doc.id !== id));
                    toast.success('Document supprimé avec succès');
                    return;
                default:
                    return;
            }

            await axios.delete(endpoint);
            
            // Update local state
            switch(type) {
                case 'product':
                    setProducts(products.filter(product => product.id !== id));
                    toast.success('Produit supprimé avec succès');
                    break;
                default:
                    break;
            }
            setError(null);
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message;
            setError(errorMsg);
            toast.error(`Erreur lors de la suppression: ${errorMsg}`);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (product) => {
        setIsEditing(true);
        setSelectedProduct(product);
        setNewprod(product.nouveaute);
        setInCalibrage(product.calibrage ? true : false);
        setInPromotion(product.promotion > 0);
        console.log(product)
        try {
            // First reset all form states
            setNewProduct({
                title: product.title,
                description: product.description || '',
                price: product.price,
                category_id: product.category_id,
                sub_category_id: product.sub_category_id || '',
                banner_image: product.banner_image || '',
                banner_imageFile: null,
                images: product.images || [],
                main_caracteristiques: product.main_caracteristiques || {},
                secondary_caracteristiques: product.secondary_caracteristiques || {},
                promotion: product.promotion || 0,
                nouveaute: product.nouveaute || false,
                calibrage: product.calibrage || '',
                documents: product.documents || []
            });

            // Set images for preview with proper path handling
            const imagesToPreview = (product.images || []).map(img => {
                // The server stores paths like "uploads/products/filename.jpg"
                const fullPath = img.startsWith('http') ? img : `${SERVER}/${img}`;
                return {
                    preview: fullPath,
                    originalPath: img, // Keep the original path from DB
                    isExisting: true
                };
            });
            setProductImages(imagesToPreview);

            // Set existing documents from server
            setProductDocuments(product.documents || []);

            // Set related products - ensure we have an array of IDs
            const relatedIds = product.related_products 
                ? Array.isArray(product.related_products) 
                    ? product.related_products.map(p => typeof p === 'object' ? p.id : p)
                    : []
                : [];
            setSelectedRelatedProducts(relatedIds.filter(id => id !== product.id));


            // Expand characteristics sections if they exist
            if (Object.keys(product.main_caracteristiques || {}).length > 0) {
                setDisplayPrimaryCaracteristiques(true);
            }
            if (Object.keys(product.secondary_caracteristiques || {}).length > 0) {
                setDisplaySecondaryCaracteristiques(true);
            }

            toast.info('Mode édition activé');
            setError(null);
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message;
            setError(errorMsg);
            toast.error(`Erreur: ${errorMsg}`);
        }
    };    
    const handleImageDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files).filter(file =>
            file.type.startsWith('image/')
        );
        const newImages = files.map(file => ({
            file,
            preview: URL.createObjectURL(file),
        }));
        setProductImages(prev => [...prev, ...newImages]);
    };


    const getSubCategoriesForProduct = () => {
        if (!newProduct.category_id) return [];
        return subCategories.filter(sub => 
            String(sub.category_id) === String(newProduct.category_id)
        );
    };

    if (loading) return <div className="loading">Chargement...</div>;
    return (
        <div className='admin'>
            {isModalOpen && (
                <div className="image-modal" onClick={closeImageModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <span className="close-button" onClick={closeImageModal}>&times;</span>
                        <img src={selectedImage.startsWith('blob:') ? selectedImage : `${selectedImage}`} alt="Full size" />
                    </div>
                </div>
            )}

            {/* Product View Modal */}
            {isViewModalOpen && viewProduct && (
                <div className="product-view-modal" onClick={closeViewModal}>
                    <div className="modal-content view-modal-content" onClick={e => e.stopPropagation()}>
                        <span className="close-button" onClick={closeViewModal}>&times;</span>
                        <h2>Détails du produit</h2>
                        
                        <div className="product-view-grid">
                            <div className="product-view-section">
                                <h3>Informations générales</h3>
                                <div className="info-item">
                                    <strong>Nom:</strong> {viewProduct.title}
                                </div>
                                <div className="info-item">
                                    <strong>Prix:</strong> {formatPrice(viewProduct.price)}
                                </div>
                                <div className="info-item">
                                    <strong>Catégorie:</strong> {categories.find(cat => cat.id === viewProduct.category_id)?.title || 'N/A'}
                                </div>
                                <div className="info-item">
                                    <strong>Sous-catégorie:</strong> {subCategories.find(sub => sub.id === viewProduct.sub_category_id)?.title || 'N/A'}
                                </div>
                                <div className="info-item">
                                    <strong>Promotion:</strong> {viewProduct.promotion > 0 ? `${viewProduct.promotion}%` : 'Non'}
                                </div>
                                <div className="info-item">
                                    <strong>Nouveauté:</strong> {viewProduct.nouveaute ? 'Oui' : 'Non'}
                                </div>
                                {viewProduct.calibrage && (
                                    <div className="info-item">
                                        <strong>Calibrage:</strong> {viewProduct.calibrage}
                                    </div>
                                )}
                                {viewProduct.description && (
                                    <div className="info-item">
                                        <strong>Description:</strong>
                                        <p>{viewProduct.description}</p>
                                    </div>
                                )}
                            </div>

                            <div className="product-view-section">
                                <h3>Images</h3>
                                <div className="view-images-grid">
                                    {viewProduct.banner_image && (
                                        <div className="view-image-item">
                                            <img 
                                                src={`${SERVER}/${viewProduct.banner_image}`} 
                                                alt="Banner" 
                                                onClick={() => openImageModal(`${SERVER}/${viewProduct.banner_image}`)}
                                            />
                                            <span>Image principale</span>
                                        </div>
                                    )}
                                    {viewProduct.images && viewProduct.images.map((img, index) => (
                                        <div key={index} className="view-image-item">
                                            <img 
                                                src={`${SERVER}/${img}`} 
                                                alt={`Image ${index + 1}`}
                                                onClick={() => openImageModal(`${SERVER}/${img}`)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {Object.keys(viewProduct.main_caracteristiques || {}).length > 0 && (
                                <div className="product-view-section">
                                    <h3>Caractéristiques principales</h3>
                                    <div className="characteristics-view">
                                        {Object.entries(viewProduct.main_caracteristiques).map(([key, char]) => (
                                            <div key={key} className="char-item">
                                                <strong>{char.title}:</strong> {char.value} {char.unity}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {Object.keys(viewProduct.secondary_caracteristiques || {}).length > 0 && (
                                <div className="product-view-section">
                                    <h3>Caractéristiques secondaires</h3>
                                    <div className="characteristics-view">
                                        {Object.entries(viewProduct.secondary_caracteristiques).map(([key, char]) => (
                                            <div key={key} className="char-item">
                                                <strong>{char.title}:</strong> {char.value} {char.unity}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {viewProduct.documents && viewProduct.documents.length > 0 && (
                                <div className="product-view-section">
                                    <h3>Documents</h3>
                                    <div className="documents-view">
                                        {viewProduct.documents.map((doc) => (
                                            <div key={doc.id} className="doc-item">
                                                <a 
                                                    href={`${SERVER}/${doc.file_path}`} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    📄 {doc.title}
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {viewProduct.related_products && viewProduct.related_products.length > 0 && (
                                <div className="product-view-section">
                                    <h3>Produits associés</h3>
                                    <div className="related-view">
                                        {viewProduct.related_products.map((relProd) => (
                                            <div key={relProd.id} className="related-item">
                                                • {relProd.title}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Error Message */}
            {error && (
                <div className="error-message">
                    {error}
                    <button onClick={() => setError(null)}>×</button>
                </div>
            )}

            {/* Search Bar */}
            <div className="search-filter-container">
                <input
                    type="text"
                    placeholder="Rechercher..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                    className="search-input"
                />
                
                {activeTab === 'products' && (
                    <>
                        <select
                            value={categoryFilter}
                            onChange={(e) => {
                                setCategoryFilter(e.target.value);
                                setSubCategoryFilter('');
                                setCurrentPage(1);
                            }}
                            className="filter-select"
                        >
                            <option value="">Toutes les catégories</option>
                            {categories.map(category => (
                                <option key={category.id} value={category.id}>{category.title}</option>
                            ))}
                        </select>
                        
                        <select
                            value={subCategoryFilter}
                            onChange={(e) => {
                                setSubCategoryFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="filter-select"
                            disabled={!categoryFilter}
                        >
                            <option value="">Toutes les sous-catégories</option>
                            {subCategories
                                .filter(sub => sub.category_id === Number(categoryFilter))
                                .map(subCategory => (
                                    <option key={subCategory.id} value={subCategory.id}>{subCategory.title}</option>
                                ))}
                        </select>
                    </>
                )}
            </div>

            {/* Import Product Modal */}
            {isImportModalOpen && (
                <div className="product-view-modal" onClick={closeImportModal}>
                    <div className="modal-content import-modal-content" onClick={e => e.stopPropagation()}>
                        <span className="close-button" onClick={closeImportModal}>&times;</span>
                        <h2>Importer un produit depuis Kern</h2>
                        
                        <div className="import-modal-body">
                            <p className="import-instructions">
                                Entrez l'URL d'un produit du site Kern (kern-sohn.com) pour importer automatiquement ses informations.
                            </p>
                            
                            <div className="import-url-input">
                                <label htmlFor="import-url">URL du produit Kern:</label>
                                <input
                                    id="import-url"
                                    type="text"
                                    placeholder="https://www.kern-sohn.com/shop/fr/produits/..."
                                    value={importUrl}
                                    onChange={(e) => setImportUrl(e.target.value)}
                                    disabled={importLoading}
                                />
                            </div>

                            {importError && (
                                <div className="import-error">
                                    {importError}
                                </div>
                            )}

                            <div className="import-modal-actions">
                                <button 
                                    className="import-button"
                                    onClick={handleImportProduct}
                                    disabled={importLoading}
                                >
                                    {importLoading ? 'Importation en cours...' : 'Importer le produit'}
                                </button>
                                <button 
                                    className="cancel-button"
                                    onClick={closeImportModal}
                                    disabled={importLoading}
                                >
                                    Annuler
                                </button>
                            </div>

                            <div className="import-example">
                                <strong>Exemple d'URL:</strong>
                                <code>https://www.kern-sohn.com/shop/fr/produits/balances-de-laboratoire/balances-de-poche/cm-150-1n/</code>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Products Tab */}
            {activeTab === 'products' && (
                <div className="admin-section">
                    <div className="section-header">
                        <h2>Produits</h2>
                        <button className="import-kern-button" onClick={openImportModal}>
                            📥 Importer depuis Kern
                        </button>
                    </div>
                    
                    {/* Product Form */}
                    <div className="admin-form product-form">
                        <div className="form-row-first">
                            <div className="form-field">
                                <label htmlFor="product-title">Nom du produit *</label>
                                <input
                                    id="product-title"
                                    type="text"
                                    placeholder="Entrez le nom du produit"
                                    value={newProduct.title}
                                    onChange={(e) => setNewProduct({...newProduct, title: e.target.value})}
                                />
                            </div>
                            <div className="form-field">
                                <label htmlFor="product-price">Prix (€) *</label>
                                <input
                                    id="product-price"
                                    type="number"
                                    step="0.01"
                                    placeholder="0.00"
                                    value={newProduct.price}
                                    onChange={(e) => setNewProduct({...newProduct, price: parseFloat(e.target.value) || ''})}
                                />
                            </div>
                        </div>
                        
                        <div className="form-row">
                            <div className="form-field">
                                <label htmlFor="banner-image">Image principale</label>
                                <div className="banner-image-upload">
                                    {newProduct.banner_image && !newProduct.banner_imageFile && (
                                        <img 
                                            src={`${SERVER}/${newProduct.banner_image}`} 
                                            alt="Banner preview" 
                                            style={{width: '100px', height: '100px', objectFit: 'cover', marginRight: '10px'}}
                                        />
                                    )}
                                    {newProduct.banner_imageFile && (
                                        <img 
                                            src={URL.createObjectURL(newProduct.banner_imageFile)} 
                                            alt="Banner preview" 
                                            style={{width: '100px', height: '100px', objectFit: 'cover', marginRight: '10px'}}
                                        />
                                    )}
                                    <input
                                        id="banner-image"
                                        type="file"
                                        name='banner_image'
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setNewProduct({
                                                    ...newProduct,
                                                    banner_imageFile: file
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-field">
                                <label htmlFor="product-category">Catégorie *</label>
                                <select
                                    id="product-category"
                                    value={newProduct.category_id}
                                    onChange={(e) => {
                                        const categoryId = e.target.value;
                                        setNewProduct({
                                            ...newProduct,
                                            category_id: categoryId,
                                            sub_category_id: ''
                                        });
                                    }}
                                >
                                    <option value="">Sélectionner une catégorie</option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.title}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-field">
                                <label htmlFor="product-subcategory">Sous-catégorie</label>
                                <select
                                    id="product-subcategory"
                                    value={newProduct.sub_category_id}
                                    onChange={(e) => setNewProduct({...newProduct, sub_category_id: e.target.value})}
                                    disabled={!newProduct.category_id}
                                >
                                    <option value="">Sélectionner une sous-catégorie</option>
                                    {getSubCategoriesForProduct().map((subCategory) => (
                                        <option key={subCategory.id} value={subCategory.id}>{subCategory.title}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        
                        <div className="form-row">
                            <div className="form-field full-width">
                                <label htmlFor="product-description">Description</label>
                                <textarea
                                    id="product-description"
                                    placeholder="Entrez la description du produit"
                                    value={newProduct.description}
                                    onChange={(e) => setNewProduct({...newProduct, description: e.target.value})}
                                    rows="4"
                                />
                            </div>
                        </div>

                        <div className={`form-row ${inPromotion ? 'promotion-active' : ''}`}>
                            <label className='promotion-label'>
                                <input
                                    type="checkbox"
                                    checked={inPromotion}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setInPromotion(checked);
                                        if (!checked) {
                                            setNewProduct({ ...newProduct, promotion: 0 });
                                        }
                                    }}
                                />
                                Promotion
                            </label>
                            {inPromotion && (
                                <input
                                    type="number"
                                    max={100}
                                    min={0}
                                    placeholder="%"
                                    value={newProduct.promotion}
                                    onChange={(e) => setNewProduct({...newProduct, promotion: parseFloat(e.target.value) || 0})}
                                />  
                            )}
                        </div>

                        <div className="form-row">
                            <label className='promotion-label'>
                                <input
                                    type="checkbox"
                                    checked={newProd.nouveaute}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setNewprod(checked);
                                        setNewProduct({ ...newProduct, nouveaute: checked });
                                    }}
                                />
                                Nouveau Produit
                            </label>
                        </div>

                        <div className={`form-row ${inCalibrage ? 'promotion-active' : ''}`}>
                            <label className='promotion-label'>
                                <input
                                    type="checkbox"
                                    checked={inCalibrage}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setInCalibrage(checked);
                                        if (!checked) {
                                            setNewProduct({ ...newProduct, calibrage: '' });
                                        }
                                    }}
                                />
                                Calibrage
                            </label>
                            {inCalibrage && (
                                <div className="calibrage-inputs" style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                    <input
                                        type="number"
                                        min={0}
                                        placeholder="Min"
                                        value={newProduct.calibrage?.split(' ')[0] || ''}
                                        onChange={(e) => {
                                            const min = e.target.value;
                                            const max = newProduct.calibrage?.split(' ')[1] || '';
                                            setNewProduct({...newProduct, calibrage: min && max ? `${min} ${max}` : min || max || ''});
                                        }}
                                    />
                                    <span>-</span>
                                    <input
                                        type="number"
                                        min={0}
                                        placeholder="Max"
                                        value={newProduct.calibrage?.split(' ')[1] || ''}
                                        onChange={(e) => {
                                            const min = newProduct.calibrage?.split(' ')[0] || '';
                                            const max = e.target.value;
                                            setNewProduct({...newProduct, calibrage: min && max ? `${min} ${max}` : min || max || ''});
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Additional Images */}
                        <div className="image-uploader">
                            <h3>Images supplémentaires</h3>
                            <div
                                className="drop-zone"
                                onDrop={handleImageDrop}
                                onDragOver={handleDragOver}
                                onClick={() => document.getElementById('images').click()}
                            >
                                <p>Glissez-déposez des images ici ou cliquez pour sélectionner</p>
                                <input
                                    id="images"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleImageUpload}
                                    hidden
                                />
                            </div>

                            <div className="images-preview">
                                {productImages.map((image, index) => (
                                    <div key={index} className="image-preview-item">
                                        <img
                                            src={image.preview}
                                            alt={`Product ${index}`}
                                            onClick={() => openImageModal(image.preview)}
                                        />
                                        <button
                                            className="delete-image-button"
                                            onClick={() => handleRemoveImage(index)}
                                            title="Supprimer l'image"
                                        >
                                            <FaDeleteLeft size={16} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Documents */}
                        <h3>Documents</h3>
                        <div className="form-row">
                            <input
                                type="text"
                                placeholder="Titre du document"
                                value={newDocument.title}
                                onChange={(e) => setNewDocument({...newDocument, title: e.target.value})}
                            />
                            <input
                                type="file"
                                name="documents"
                                accept="application/pdf"
                                onChange={handleDocumentUpload}
                            />
                            <button className="add-document-button" onClick={handleAddDocument}>Ajouter Document</button>
                        </div>
                        <div className="documents-list">
                            {/* Existing documents from the server */}
                            {productDocuments.map((doc) => (
                                <div key={doc.id} className="document-item">
                                    <a 
                                        href={`${SERVER}/${doc.file_path}`} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        {doc.title}
                                    </a>
                                    <button 
                                        className="delete-button"
                                        onClick={() => handleDelete('document', doc.id)}
                                    >
                                        <FaDeleteLeft size={16} />
                                    </button>
                                </div>
                            ))}
                            
                            {/* New documents being added */}
                            {newProduct.documents.map((doc, index) => (
                                <div key={`new-${index}`} className="document-item">
                                    <span>{doc.title}</span>
                                    <button 
                                        className="delete-button"
                                        onClick={() => handleRemoveDocument(index)}
                                    >
                                        <FaDeleteLeft size={16} />
                                    </button>
                                </div>
                            ))}
                        </div>
                            
                        <div className="related-products-section">
                            <h3>Produits Associés</h3>
                            <div className="related-products-selector">
                                {products.filter(p => p.id !== selectedProduct?.id).map(product => (
                                    <div key={product.id} className="related-product-item">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={selectedRelatedProducts.includes(product.id)}
                                                onChange={() => handleSelectRelatedProduct(product.id)}
                                            />
                                            {product.title}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        {/* Characteristics sections */}
                        <h3>
                            Caractéristiques principales 
                            <button onClick={() => setDisplayPrimaryCaracteristiques(!displayPrimaryCaracteristiques)}>
                                <FiChevronDown />
                            </button>
                            <button 
                                id='load-default-button'
                                className="load-default-button" 
                                onClick={() => handleLoadDefaultCharacteristics('main')}
                                title="Charger les caractéristiques par défaut"
                            >
                                Charger par défaut
                            </button>
                        </h3>
                        {displayPrimaryCaracteristiques && (
                            <div className="characteristics-list">
                                {Object.entries(newProduct.main_caracteristiques).map(([key, char]) => (
                                    editingChar && editingChar.key === key && editingCharType === 'main' ? (
                                        <div key={key} className="characteristics-edit-form">
                                            <input
                                                type="text"
                                                placeholder="Titre"
                                                value={editingChar.title}
                                                onChange={(e) => setEditingChar({...editingChar, title: e.target.value})}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Valeur"
                                                value={editingChar.value}
                                                onChange={(e) => setEditingChar({...editingChar, value: e.target.value})}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Unité"
                                                value={editingChar.unity}
                                                onChange={(e) => setEditingChar({...editingChar, unity: e.target.value})}
                                            />
                                            <button onClick={handleSaveEditCharacteristic}>Sauvegarder</button>
                                            <button onClick={handleCancelEditCharacteristic}>Annuler</button>
                                        </div>
                                    ) : (
                                        <div 
                                            key={key} 
                                            id='characteristics-item' 
                                            className={`characteristics-item ${draggedChar === key ? 'dragging' : ''}`}
                                            draggable
                                            onDragStart={(e) => handleDragStart(e, key, 'main')}
                                            onDragOver={handleDragOver}
                                            onDrop={(e) => handleDrop(e, key, 'main')}
                                            onDragEnd={handleDragEnd}
                                        >
                                            
                                            <strong>{char.title}:</strong> {char.value} {char.unity}
                                            <div className="admin-actions">
                                                <button 
                                                    className="edit-button" 
                                                    onClick={() => handleEditCharacteristic(key, char, 'main')}
                                                    title="Modifier"
                                                >
                                                    <MdOutlineModeEdit size={16} />
                                                </button>
                                                <button 
                                                    className="delete-button" 
                                                    onClick={() => handleDelete('mainChar', key)}
                                                    title="Supprimer"
                                                >
                                                    <TiDelete size={16} />

                                                </button>
                                                <span className="drag-handle">⋮⋮</span>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        )}
                        {isAddingMainChar ? (
                            <div className="characteristics-form">
                                <input
                                    type="text"
                                    placeholder="Titre de la caractéristique"
                                    value={newMainChar.title}
                                    onChange={(e) => setNewMainChar({...newMainChar, title: e.target.value})}
                                />
                                <input
                                    type="text"
                                    placeholder="Valeur"
                                    value={newMainChar.value}
                                    onChange={(e) => setNewMainChar({...newMainChar, value: e.target.value})}
                                />
                                <input
                                    type="text"
                                    placeholder="Unité"
                                    value={newMainChar.unity}
                                    onChange={(e) => setNewMainChar({...newMainChar, unity: e.target.value})}
                                />
                                <button onClick={handleAddMainCharacteristic}>Ajouter</button>
                                <button onClick={() => setIsAddingMainChar(false)}>Annuler</button>
                            </div>
                        ) : (
                            <button className='add-char-button' onClick={() => setIsAddingMainChar(true)}>
                                Ajouter une caractéristique principale
                            </button>
                        )}

                        <h3>
                            Caractéristiques secondaires 
                            <button onClick={() => setDisplaySecondaryCaracteristiques(!displaySecondaryCaracteristiques)}>
                                <FiChevronDown />
                            </button>
                            <button 
                                id='load-default-button'
                                className="load-default-button" 
                                onClick={() => handleLoadDefaultCharacteristics('secondary')}
                                title="Charger les caractéristiques par défaut"
                            >
                                Charger par défaut
                            </button>
                        </h3>
                        {displaySecondaryCaracteristiques && (
                            <div className="characteristics-list">
                                {Object.entries(newProduct.secondary_caracteristiques).map(([key, char]) => (
                                    editingChar && editingChar.key === key && editingCharType === 'secondary' ? (
                                        <div key={key} className="characteristics-edit-form">
                                            <input
                                                type="text"
                                                placeholder="Titre"
                                                value={editingChar.title}
                                                onChange={(e) => setEditingChar({...editingChar, title: e.target.value})}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Valeur"
                                                value={editingChar.value}
                                                onChange={(e) => setEditingChar({...editingChar, value: e.target.value})}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Unité"
                                                value={editingChar.unity}
                                                onChange={(e) => setEditingChar({...editingChar, unity: e.target.value})}
                                            />
                                            <button onClick={handleSaveEditCharacteristic}>Sauvegarder</button>
                                            <button onClick={handleCancelEditCharacteristic}>Annuler</button>
                                        </div>
                                    ) : (
                                        <div 
                                            key={key} 
                                            id='characteristics-item' 
                                            className={`characteristics-item ${draggedChar === key ? 'dragging' : ''}`}
                                            draggable
                                            onDragStart={(e) => handleDragStart(e, key, 'secondary')}
                                            onDragOver={handleDragOver}
                                            onDrop={(e) => handleDrop(e, key, 'secondary')}
                                            onDragEnd={handleDragEnd}
                                        >
                                            <span className="drag-handle">⋮⋮</span>
                                            <strong>{char.title} : </strong> {char.value} {char.unity}
                                            <div className="admin-actions">
                                                <button 
                                                    className="edit-button" 
                                                    onClick={() => handleEditCharacteristic(key, char, 'secondary')}
                                                    title="Modifier"
                                                >
                                                    <MdOutlineModeEdit size={16} />
                                                </button>
                                                <button 
                                                    className="delete-button" 
                                                    onClick={() => handleDelete('secondaryChar', key)}
                                                    title="Supprimer"
                                                >
                                                    <FaDeleteLeft size={16} />
                                                </button>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        )}
                        {isAddingSecondaryChar ? (
                            <div className="characteristics-form">
                                <input
                                    type="text"
                                    placeholder="Titre de la caractéristique"
                                    value={newSecondaryChar.title}
                                    onChange={(e) => setNewSecondaryChar({...newSecondaryChar, title: e.target.value})}
                                />
                                <input
                                    type="text"
                                    placeholder="Valeur"
                                    value={newSecondaryChar.value}
                                    onChange={(e) => setNewSecondaryChar({...newSecondaryChar, value: e.target.value})}
                                />
                                <input
                                    type="text"
                                    placeholder="Unité"
                                    value={newSecondaryChar.unity}
                                    onChange={(e) => setNewSecondaryChar({...newSecondaryChar, unity: e.target.value})}
                                />
                                <button onClick={handleAddSecondaryCharacteristic}>Ajouter</button>
                                <button onClick={() => setIsAddingSecondaryChar(false)}>Annuler</button>
                            </div>
                        ) : (
                            <button className='add-char-button' onClick={() => setIsAddingSecondaryChar(true)}>
                                Ajouter une caractéristique secondaire
                            </button>
                        )}

                        <div className="form-actions">
                            {isEditing ? (
                                <>
                                    <button className="update-button" onClick={handleUpdate}>
                                        Mettre à  jour le produit
                                    </button>
                                    <button className="cancel-button" onClick={() => { 
                                        setIsEditing(false); 
                                    }}>
                                        Annuler
                                    </button>
                                </>
                            ) : (
                                <button className="add-button" onClick={handleAddProduct}>
                                    Ajouter un produit
                                </button>
                            )}
                        </div>
                    </div>
                    
                    {/* Products Table */}
                    <div className="admin-table-container">
                        {/* Filter Controls */}
                        <div className="table-filters">
                            <div className="filter-group">
                                <label htmlFor="search-filter">Rechercher:</label>
                                <input
                                    id="search-filter"
                                    type="text"
                                    placeholder="Rechercher par nom, description ou prix..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="filter-input"
                                />
                            </div>
                            
                            <div className="filter-group">
                                <label htmlFor="category-filter">Catégorie:</label>
                                <select
                                    id="category-filter"
                                    value={categoryFilter}
                                    onChange={(e) => {
                                        setCategoryFilter(e.target.value);
                                        setSubCategoryFilter(''); // Reset subcategory when category changes
                                    }}
                                    className="filter-select"
                                >
                                    <option value="">Toutes les catégories</option>
                                    {categories.map(cat => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="filter-group">
                                <label htmlFor="subcategory-filter">Sous-catégorie:</label>
                                <select
                                    id="subcategory-filter"
                                    value={subCategoryFilter}
                                    onChange={(e) => setSubCategoryFilter(e.target.value)}
                                    className="filter-select"
                                    disabled={!categoryFilter}
                                >
                                    <option value="">Toutes les sous-catégories</option>
                                    {categoryFilter && subCategories
                                        .filter(sub => String(sub.category_id) === String(categoryFilter))
                                        .map(sub => (
                                            <option key={sub.id} value={sub.id}>
                                                {sub.title}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            
                            <button 
                                className="clear-filters-button"
                                onClick={() => {
                                    setSearchTerm('');
                                    setCategoryFilter('');
                                    setSubCategoryFilter('');
                                }}
                            >
                                Réinitialiser les filtres
                            </button>
                        </div>

                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '100px' }}>Image</th>
                                    <th>Nom</th>
                                    <th>Prix</th>
                                    <th>Catégorie</th>
                                    <th>Sous-catégorie</th>
                                    <th>En Promotion</th>
                                    <th>Nouveauté</th>
                                    <th>Calibrage</th>
                                    <th style={{ width: '200px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentProducts.length > 0 ? (
                                    currentProducts.map((product) => {
                                        const category = categories.find(cat => cat.id === product.category_id);
                                        const subCategory = subCategories.find(sub => sub.id === product.sub_category_id);
                                        
                                        return (
                                            <tr key={product.id}>
                                                <td>
                                                    {product.banner_image && (
                                                        <img 
                                                            src={`${SERVER}/${product.banner_image}`} 
                                                            alt={product.title} 
                                                            className="table-image"
                                                            onClick={() => openImageModal(`${SERVER}/${product.banner_image}`)}
                                                        />
                                                    )}
                                                </td>
                                                <td>{product.title}</td>
                                                <td>{formatPrice(product.price)}</td>
                                                <td>{category?.title || 'N/A'}</td>
                                                <td>{subCategory?.title || 'N/A'}</td>
                                                <td>{product.promotion === 0 ? "Non" : `${product.promotion}%`}</td>
                                                <td>{product.nouveaute ? "Oui" : "Non"}</td>
                                                <td>{product.calibrage}</td>
                                                <td>
                                                    <div className="actions-container">
                                                        <div className="admin-actions">
                                                            <button 
                                                                className="view-button"
                                                                onClick={() => openViewModal(product)}
                                                                title="Voir les détails"
                                                            >
                                                                <FaEye size={16} />
                                                            </button>
                                                            <button 
                                                                className="edit-button"
                                                                onClick={() => handleEdit(product)}
                                                                title="Modifier"
                                                            >
                                                                <MdOutlineModeEdit />
                                                            </button>
                                                            <button 
                                                                className="delete-button"
                                                                onClick={() => handleDelete('product', product.id)}
                                                                title="Supprimer"
                                                            >
                                                                <MdDeleteOutline />
                                                            </button>
                                                        </div>
                                                        <TranslationButton
                                                            data={product}
                                                            type="product"
                                                            onTranslationSaved={() => {
                                                                window.location.reload();
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="no-products">
                                            Aucun produit trouvé
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        
                        {/* Pagination */}
                        {filteredProducts.length > itemsPerPage && (
                            <div className="pagination">
                                {Array.from({ length: Math.ceil(filteredProducts.length / itemsPerPage) }).map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => paginate(index + 1)}
                                        className={currentPage === index + 1 ? 'active' : ''}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminProducts;